import axios from '@/api/$axios'
import { isWechatBrowser } from '@/utils/wechat'
import { wxPayENV } from '@/config/wx.config'
import store from '@/store'

export default {
  list ({ page, perPage, state }) {
    return axios.get(`/orders`, {
      params: { page, perPage, state }
    })
  },
  add ({ collection, resourceId, data = {}}) {
    const { name, contact, areas, detail, amount, note } = data
    const _areas = areas && areas.split('\/')
    const address = _areas && {
      name,
      contact,
      province: _areas[0],
      city: _areas[1],
      area: _areas[2],
      detail
    }
    return axios.post(`/${collection}/${resourceId}/orders`, {
      order: {
        amount,
        note,
        address
      }
    })
  },
  pay ({ id, payType }) {
    if (store.state.Organization.payType === 'offline' && payType === 'cash') {
      store.dispatch('setServiceShow', true)
      console.log('dispatch')
      return Promise.reject()
    }
    let wxPayType
    if (isWechatBrowser()) {
      wxPayType = 'JSAPI'
    } else if (wxPayENV === 'NATIVE') {
      wxPayType = 'NATIVE'
    } else {
      wxPayType = 'H5'
    }
    return axios.post(`/orders/${id}/pay`, {
      payType, wxPayType
    })
  }
}
